import { useEffect, useState } from "react";


// Hooks
import useUser from '../user/useUser'

// Services
import movementsService from "../../services/movementService";

const initFilters = {
    pageNumber: 1,
    pageSize: 10
}

const stateInit = {
    movements: [],
    totalPage: 0,
    totalResults: 0,
    stockQuantity: 0
}

const useProductHistory = (filters = initFilters) => {
    const { branch } = useUser();
    const [searchResponse, setSearchResponse] = useState(stateInit)
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const abortController = new AbortController()

        const searchHistory = () => {
            setLoading(true);
            movementsService
                .SearchHistory(filters.refId, { ...initFilters, ...filters, warehouseId: branch?.warehouseId }, { signal: abortController.signal })
                .then(res => setSearchResponse({
                    movements: res.values,
                    totalPage: res.totalPage,
                    totalResults: res.totalResults,
                    stockQuantity: res.stockQuantity
                }))
                .finally(() => setLoading(false));
        }

        if (filters?.refId && branch?.warehouseId)
            searchHistory()
        else
            setSearchResponse(stateInit);

        return () => {
            abortController.abort();
        }
    }, [filters, branch])

    return {
        ...searchResponse,
        loadingSearch: loading
    }
}

export default useProductHistory;